<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Handicap List
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row search-form">
                                    <div class="col-md-3 mt-1">
                                        <select v-model="filter.league_ids" class="form-control">
                                            <option value="">All League</option>
                                            <option v-for="league in leagues" :key="league.id" :value="league.id">{{ league.name }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <input type="text" v-model="filter.teamName" class="form-control" placeholder="Name">
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                        <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th class="text-left">Home</th>
                                        <th class="text-left">Goal Score</th>
                                        <th class="text-left">Away</th>
                                        <th class="text-left">Goal Over</th>
                                        <th class="text-left">Goal Under</th>
                                        <th class="text-left">Total Bet</th>
                                        <th class="text-left">Action</th>
                                        <th class="text-left">Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                          <td class="text-left">
                                                {{ (data.home_team_name || '-') }}
                                                <span v-if="data.is_home_team_upper === true" class="text-danger">
                                                    <span v-if="data.body_handicap == 0">= </span>
                                                    <span v-else> ( {{ data.body_handicap }}</span>
                                                    {{ formatSigned(data.body_handicap_price) }} )
                                                </span>
                                                <br>
                                                <span>
                                                    Percentage : {{ data.home_team_percentage }} %
                                                </span>
                                                <br>
                                                <span>
                                                    Amount : {{ data.total_home_team_bet_amount }}
                                                </span>
                                            </td>
                                            <td class="text-left">
                                                {{data.home_team_score}} 
                                                - 
                                                {{ data.away_team_score }}
                                            </td>
                                            <td class="text-left">
                                                {{ (data.away_team_name) || '-' }}
                                                <span v-if="data.is_home_team_upper === false" class="text-danger">
                                                    <span v-if="data.body_handicap == 0">= </span>
                                                    <span v-else>{{ data.body_handicap }}</span>
                                                    {{ formatSigned(data.body_handicap_price) }}
                                                </span>
                                                <br>
                                                <span>
                                                    Percentage : {{ data.away_team_percentage }} %
                                                </span>
                                                <br>
                                                <span>
                                                    Amount : {{ data.total_away_team_bet_amount }}
                                                </span>
                                            </td>
                                            <td class="text-left">
                                                <span>Percentage : {{ data.goal_over_percentage || 0 }} % </span>   
                                                <br>
                                                <span>
                                                    Amount : {{ data.total_goal_over_bet_amount }}
                                                </span>
                                            </td>
                                            <td class="text-left">
                                                <span>Percentage : {{ data.goal_under_percentage || 0 }} % </span>
                                                <br>
                                                <span>
                                                    Amount : {{ data.total_goal_under_bet_amount }}
                                                </span>
                                            </td>
                                            <td class="text-left">
                                                {{ data.total_bet_amount || 0 }}
                                            </td>
                                            <td class="text-left">
                                                <button v-if="data.status == '0'" v-b-modal.bv-modal-cancel class="btn btn-action btn-reject " @click="editData(data)">Cancel</button>
                                                <span v-if="data.status == '1'" class="badge badge-success">Finished</span>
                                                <span v-if="data.status == '2'" class="badge badge-danger">Canceled</span>
                                            </td>
                                            <td class="text-left">
                                                <span>{{ data.date | formatDate }}</span>
                                            </td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="table-pagination-minimal">
                                <div class="table-pagination-row">
                                    <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                        Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                    </div>
                                    <nav class="pagination-minimal">
                                        <ul>
                                            <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                                <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                    <i class="fas fa-angle-left"></i>
                                                </button>
                                            </li>
                                            <li v-for="page in metaData.last_page" :key="page"
                                                :class="{ 'active':metaData.current_page === page }"
                                                v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                                <button @click.prevent="next(page)">{{ page }}</button>
                                            </li>
                                            <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                                <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                    <i class="fas fa-angle-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <b-modal id="bv-modal-commission" ref="my-modal" title="Commission Data" hide-footer size="lg" dialog-class="commission-modal-lg">
                            <ul class="list-group" v-if="commissionData.commission_data">
                                <li class="list-group-item">
                                    Agent Name
                                    <span class="badge text-primary rounded-pill badge-16">{{ commissionData.name }}</span>
                                </li>
                                <li class="list-group-item align-items-center">
                                    Handicap
                                    <span class="badge text-primary rounded-pill badge-16">Upper : {{ commissionData.commission_data.body_high_rate }}</span>
                                    <span class="badge text-primary rounded-pill badge-16">Lower : {{ commissionData.commission_data.body_low_rate }}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    Accumulator
                                    <badge class="badge text-primary rounded-pill badge-16">2 : {{ commissionData.commission_data.moung_two_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">3 : {{ commissionData.commission_data.moung_three_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">4 : {{ commissionData.commission_data.moung_four_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">5 : {{ commissionData.commission_data.moung_five_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">6 : {{ commissionData.commission_data.moung_six_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">7 : {{ commissionData.commission_data.moung_seven_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">8 : {{ commissionData.commission_data.moung_eight_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">9 : {{ commissionData.commission_data.moung_nine_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">10 : {{ commissionData.commission_data.moung_ten_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">11 : {{ commissionData.commission_data.moung_eleven_rate }}</badge>

                                </li>
                            </ul>                    
                        </b-modal>
                        <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        <b-modal id="bv-modal-cancel" ref="my-modal" title="Cancel" hide-footer>
                            <p class="my-4">Are you sure to cancel ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="cancelChange()">Cancel</b-button>
                        </b-modal>
                        <!-- <router-link class="float" to="agent-create">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </router-link> -->
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'agentList',
        metaInfo: {
            title: "Agent List",
            titleTemplate: "%s ← BXB",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                id: '',
                leagues: [],
                dataList: [],
                commissionData: [],
                permissions: '',
                columns: {
                    code: "Code",
                    name: "Name",
                    phone: "Phone",
                    email: "Email",
                    created_at: "Created At"
                },
                filter: {
                    page: 1,
                    orderBy: "asc",
                    sortKey: "created_at",
                    limit: 10,
                    league_ids: "",
                    teamName: "",
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            ...mapActions({
                handicapListAction: 'handicapListAction',
                fixtureCancelAction: 'fixtureCancelAction',
                getAllLeaguesAction: 'getAllLeaguesAction',
            }),
            sortBy(column) {
                this.filter.sortKey = column
                if (this.filter.sortKey == column) {
                    if (this.filter.orderBy == "asc") {
                        this.filter.orderBy = "desc"
                    } else if (this.filter.orderBy == "desc") {
                        this.filter.orderBy = "asc"
                    }
                } else {
                    this.filter.orderBy = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                let option = this.filter
                await this.handicapListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.lastPage
                        this.metaData.current_page = res.data.meta.currentPage
                        this.metaData.prev_page_url = res.data.meta.prevPageUrl
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.$router.replace({ 
                            path: 'handicap', 
                            query: { 
                                page: this.filter.page, 
                                orderBy: this.filter.orderBy, 
                                sortKey: this.filter.sortKey, 
                                league_ids: this.filter.league_ids, 
                                teamName: this.filter.teamName,
                            } 
                        }).catch(()=>{})
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'handicap', 
                    query: {
                        page: 1, 
                        orderBy: 'desc', 
                        sortKey: 'created_at', 
                        league_ids: "", 
                        teamName: "",
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.id = data.id
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async cancelChange(){
                this.isLoading = true
				let option = {
					fixture_id: this.id,
				}
                console.log(this.status)
                await this.fixtureCancelAction({
                    ...option
                }).then(res => {
                    if(res.success == false){
                        this.alert = res.message
                    }else{
                        this.id = "",
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
                }).catch(err => this.isLoading = true)
            },
            formatGoalScore(item) {
                const ft = (item && item.fixture) || {};
                const hs = (ft.home_score != null) ? ft.home_score : (ft.score && ft.score.home);
                const as = (ft.away_score != null) ? ft.away_score : (ft.score && ft.score.away);
                if (hs == null || as == null) return '-';
                return `${hs} - ${as}`;
            },
            formatBetChoice(item) {
                if (!item) return '-';
                // common fields: market, pick, odd
                const market = item.market || (item.bet && item.bet.market);
                const pick = item.pick || (item.bet && item.bet.pick);
                const odd = (item.odd != null) ? item.odd : (item.bet && item.bet.odd);
                const parts = [];
                if (market) parts.push(market);
                if (pick) parts.push(pick);
                if (odd != null) parts.push(`@ ${odd}`);
                return parts.length ? parts.join(' ') : '-';
            },
            formatSigned(value) {
                if (value === null || value === undefined || value === '') return '-';
                // Accept string or number; trim whitespace
                const str = String(value).trim();
                if (str.startsWith('-')) return str; // already negative
                if (str.startsWith('+')) return str; // already positive with sign
                // Parse to number to avoid double signs on things like ' 0 '
                const num = Number(str);
                if (Number.isNaN(num)) return str; // not a number, return as-is
                return num >= 0 ? `+${num}` : String(num);
            },
            async getAllLeagues(){
				await this.getAllLeaguesAction().then(res => {
					this.leagues = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            }

        },
        mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.filter.page = this.$route.query.page
            this.filter.orderBy = this.$route.query.orderBy
            this.filter.sortKey = this.$route.query.sortKey
            this.filter.league_ids = this.$route.query.league_ids || ""
            this.filter.teamName = this.$route.query.teamName || ""
            this.getAllLeagues()
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
.badge-16 {
font-size: 16px;
}
.btn-reject {
    background-color: red;
    color: #ffffff;
}
</style>